<template>
    <button 
        class="group relative inline-flex items-center justify-center font-medium rounded-md border overflow-hidden focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        :class="[buttonType, buttonSize, buttonDisabled]"
        :disabled="isDisabled"
        v-on="$listeners"
    >
        <div v-if="icon" class="flex-shrink-0" :class="[!!$slots.default ? 'mr-2' : '']">
            <i :class="[buttonIcon, icon]"></i>
        </div>

        <slot></slot>

        <div v-if="loading" class="absolute inset-0 flex items-center justify-center" :class="buttonType">
            <svg class="animate-spin" :class="[buttonIcon, buttonIconSize]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
        </div>
    </button>
</template>

<script>
export default {
    props: {
        primary: Boolean,
        active: Boolean,
        danger: Boolean,
        extra: Boolean,
        warning: Boolean,
        success: Boolean,
        small: Boolean,
        disabled: Boolean,
        loading: Boolean,
        icon: String,
        iconOutline: Boolean,
    },
    computed: {
        isDisabled () {
            return this.disabled || this.loading
        },
        buttonType () {
            if (this.primary) return this.buttonPrimary
            if (this.active) return this.buttonActive
            if (this.danger) return this.buttonDanger
            if (this.warning) return this.buttonWarning
            if (this.success) return this.buttonSuccess
            if (this.extra) return this.buttonExtra
            return this.buttonDefault
        },
        buttonPrimary () {
            return this.isDisabled
                ? 'bg-blue-300 border-transparent text-white'
                : 'bg-blue-600 border-transparent text-white hover:bg-blue-700'
        },
        buttonActive () {
            return this.isDisabled
                ? 'bg-gray-400 border-transparent text-white'
                : 'bg-gray-700 border-transparent text-white hover:bg-gray-800'
        },
        buttonDanger () {
            return this.isDisabled
                ? 'bg-red-50 border-red-200 text-red-400'
                : 'bg-red-50 border-red-300 text-red-800 hover:bg-red-100'
        },
        buttonWarning () {
            return this.isDisabled
                ? 'bg-yellow-50 border-yellow-200 text-yellow-400'
                : 'bg-yellow-50 border-yellow-300 text-yellow-800 hover:bg-yellow-100'
        },
        buttonSuccess () {
            return this.isDisabled
                ? 'bg-green-50 border-green-200 text-green-400'
                : 'bg-green-50 border-green-300 text-green-800 hover:bg-green-100'
        },
        buttonExtra () {
            return this.isDisabled
                ? 'bg-blue-50 border-blue-200 text-blue-400'
                : 'bg-blue-50 border-blue-300 text-blue-800 hover:bg-blue-100'
        },
        buttonDefault () {
            return this.isDisabled
                ? 'bg-white border-gray-300 text-gray-500'
                : 'bg-white border-gray-300 hover:bg-gray-50 text-gray-700'
        },
        buttonSize () {
            return this.small
                ? 'text-xs px-2 py-1'
                : 'text-sm px-4 py-2'
        },
        buttonDisabled () {
            return this.isDisabled
                ? 'cursor-not-allowed'
                : 'shadow-sm'
        },
        buttonIcon () {
            if (this.primary) return 'text-white'
            if (this.danger)  return this.isDisabled ? 'text-red-300' : 'text-red-400'
            if (this.warning) return this.isDisabled ? 'text-yellow-300' : 'text-yellow-400'
            if (this.success) return this.isDisabled ? 'text-green-300' : 'text-green-400'
            if (this.extra) return this.isDisabled ? 'text-blue-300' : 'text-blue-400'
            return this.isDisabled ? 'text-gray-300' : 'text-gray-400'
        },
        buttonIconSize () {
            return this.small ? 'w-4 h-4' : 'w-5 h-5'
        },
    },
}
</script>
